import { Show, JSX } from "solid-js";
import InfoModal from "../InfoModal";
import UserMenu from "../UserMenu";

export default function SessionHeader(props: {
  title: JSX.Element;
  onNavigateBack?: () => void;
}) {
  return (
    <header class="bg-blue-500 text-white py-4 shadow relative flex-shrink-0">
      {/* centered title */}
      <h1 class="text-center text-2xl font-bold tracking-wide">{props.title}</h1>

      <div class="absolute top-4 left-4 flex gap-2">
        <Show when={props.onNavigateBack}>
          <button
            onClick={() => props.onNavigateBack?.()}
            class="w-8 h-8 rounded-full bg-white/20 hover:bg-white/30
               text-white text-sm font-bold flex items-center justify-center
               border border-white/30"
            title="Back to Sessions"
          >
            ⌂
          </button>
        </Show>
        <InfoModal />
      </div>

      <div class="absolute top-3 right-4 flex items-center gap-3">
        <UserMenu />
      </div>
    </header>
  );
}

